<template>
  <div class="column is-half">
    <div class="document">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteDisclosureInformation(document.id)"/>
      <el-tabs v-model="document.showType"  @tab-click="handleUpdate">
        <el-tab-pane label="Документ" name="document">
            <b-field label="Название документа">
                <b-input v-model="document.name" placeholder="Введите название документа" @change="handleUpdate" />
            </b-field>
            <span class="link" @click="handleloadFile" v-if="!document.file">
              Загрузить документ
            </span>
            <span v-else>
              <span class="link">{{document.file | path}}</span>
              <span class="delete-document" @click="deleteDisclosureInformationFile(document.id)">X</span>
            </span>
            <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
        </el-tab-pane>
        <el-tab-pane label="Ссылка" name="url">
          <b-field label="Название">
            <b-input v-model="document.name" placeholder="Введите название cсылки" @change="handleUpdate" />
          </b-field>
          <b-field label="Ссылка">
            <b-input v-model="document.url" placeholder="Введите ссылку" @change="handleUpdate" />
          </b-field>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DocumentItem',
  data () {
    return {
      updateTimer: null
    }
  },
  props: {
    document: {
      required: true
    }
  },
  filters: {
    path (path) {
      return path.split('/').pop()
    }
  },
  methods: {
    ...mapActions(['deleteDisclosureInformation', 'loadDisclosureInformationFile', 'updateDisclosureInformation']),
    handleUpdate () {
      this.updateDisclosureInformation(this.document)
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('document', file)
      this.document.newFile = formData
      this.document.file = file.name
      this.handleUpdate()
      this.$forceUpdate()
    },
    deleteDisclosureInformationFile () {
      this.document.newFile = null
      this.document.file = ''
      this.handleUpdate()
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    }
  }
}
</script>
<style scoped>
.document {
  background: #eee;
  padding: 25px;
  position: relative;
}
.document .delete-icon {
  top: -10px;
  right: -10px;
}
.delete-document {
  color: gray;
  font-size: 20px;
  vertical-align: middle;
  margin: 0 0 0 7px;
  font-family: monospace;
  cursor: pointer;
}
</style>
<style>
.el-tabs__item {
  color: #7957d5 !important;
}
.el-tabs__active-bar {
  background:  #7957d5;
  transition: none;
}
</style>



// WEBPACK FOOTER //
// DisclosureItem.vue?778133f0